<template>
    <div style="">
        <div style="margin:0 -12px;" v-if="is_page_init">
            <div class="container" style="height: 100%;">
                <div class="row" style="height: 100%">
                    <div class="col" style="height: 100%">
                        <div class="text-center" style="height: 100%">
                            <div class="spinner-grow" style="margin:100px 0;color:#E7E7FF;">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" v-else>
            <div class="row">
                <div class="col text-center">
                    <div style="padding-top:20px; ">
                        <b>申込フォーム</b>
                    </div>
                </div>
            </div>
            <br />
            <div class="row" v-if="is_auth">
                <div class="col">
                    <div style="padding:0 10px;">
                        <div class="row">
                            <div class="col">
                                <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                    参加イベント
                                </div>
                                <h5>{{ event.thumbnail }}</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <br />
                                <div>
                                    <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                        お名前
                                    </div>
                                </div>
                                <input type="text" class="luna-form-control" id="user_name" name="user_name"
                                    placeholder="名前を入力" v-model="user.name" />
                                <br />
                                <div>
                                    <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                        性別
                                    </div>
                                </div>
                                <v-select name="sex" :options="sexs" v-model="sex" placeholder="選択してください"
                                    v-on:input="chengeSex">
                                </v-select>
                                <br />
                                <div>
                                    <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                        性癖
                                    </div>
                                </div>
                                <v-select name="type" :options="types" v-model="type" placeholder="選択してください">
                                </v-select>
                                <br />
                                <div>
                                    <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                        電話番号
                                    </div>
                                </div>
                                <input type="text" class="luna-form-control" id="comment" name="comment"
                                    placeholder="記入してください（ハイフンなし）" v-model="user.tel" />
                                <br />
                                <div>
                                    <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                        メールアドレス
                                    </div>
                                </div>
                                <input type="text" class="luna-form-control" id="comment" name="comment"
                                    placeholder="記入してください" v-model="user.email" />
                                <div v-if="event.event_type != 0">
                                    <br />
                                    <div>
                                        <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                            席種
                                        </div>
                                    </div>
                                    <v-select name="sex" :options="seat_types_2" v-model="seat_type" placeholder="選択してください"
                                        v-on:input="chengeSex" v-if="event.event_type == 1">
                                    </v-select>
                                    <v-select name="sex" :options="seat_types_3" v-model="seat_type" placeholder="選択してください"
                                        v-on:input="chengeSex" v-else-if="event.event_type == 2">
                                    </v-select>
                                </div>
                                <br />
                                <template v-if="!isPrepaymentOnlyRegistrationClosed">
                                    <div>
                                        <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                            決済方法
                                        </div>
                                    </div>
                                    <v-select name="payment" :options="currentPaymentOptions" v-model="payment"
                                        :selectable="isPaymentSelectable" placeholder="選択してください"
                                        data-testid="payment-method-select">
                                    </v-select>
                                    <div v-if="isPrepaymentOnly" class="text-muted"
                                        style="font-size:11px;padding-top:6px;" data-testid="prepayment-only-notice">
                                        ※ このイベントは事前決済のみ対応しております
                                    </div>
                                    <br />
                                </template>
                                <div>
                                    <div style="color:#6B4EFF;font-size:11px;padding-bottom:5px;">
                                        申込出演者名（いる場合は選択してください
                                    </div>
                                </div>
                                <v-select name="player" :options="players" v-model="player" placeholder="選択してください"
                                    v-bind:clearable="false">
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="row justify-content-center">
                        <div class="col-7">
                            <div class="d-grid gap-2" style="padding: 0 5px;">
                                <a :href="'/event/details/' + this.$route.params['eid']" type="button"
                                    class="btn btn-luna-d" style="font-size:12px;">イベントページへ戻る</a>
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                    <div class="row" style="background:#E5E0FE;">
                        <div class="col">
                            <div style="padding:0 10px;">
                                <div class="row">
                                    <div class="col">
                                        <br />
                                        <small style="color:#6B4EFF;">
                                            <p>注意事項</p>
                                            ■ 決済完了後のチケットのキャンセルはできません。<br>
                                            <template v-if="event.owner_status == 1">
                                                ■ 事前決済は{{ event.deadline_at_text }}までに決済をお願いします。<br>
                                                <template v-if="isPrepaymentOnly">
                                                    ■ 支払期限までに決済が完了しない場合、ご予約は自動的にキャンセルされます。
                                                </template>
                                                <template v-else>
                                                    ■ 支払い期限を過ぎたご予約は自動的に当日決済扱いとなります
                                                </template>
                                            </template>
                                        </small>
                                        <div style="padding:20px;">
                                            <div class="d-grid gap-2" style="padding: 0 5px">
                                                <div class="error-text text-center" id="error-box" v-if="is_item_error">
                                                    <i class="bi bi-x-circle-fill"></i>名前、性別、性癖を入力してください。
                                                </div>
                                                <div class="error-text text-center" id="error-box" v-if="is_tel_error">
                                                    <i class="bi bi-x-circle-fill"></i>電話番号を正しく入力してください。
                                                </div>
                                                <div class="error-text text-center" id="error-box" v-if="is_email_error">
                                                    <i class="bi bi-x-circle-fill"></i>メールアドレスを正しく入力してください。
                                                </div>
                                                <div class="error-text text-center" id="error-box"
                                                    v-if="isPrepaymentOnlyRegistrationClosed"
                                                    data-testid="prepayment-only-registration-closed">
                                                    <i class="bi bi-x-circle-fill"></i>支払期限を過ぎたため、申し込み受付は終了しました。
                                                </div>
                                                <button type="button" class="btn btn-luna"
                                                    style="font-size: 18px; padding: 12px 0" @click="setRecruit()"
                                                    v-if="!isPrepaymentOnlyRegistrationClosed">
                                                    <div style="font-size:10px">上記の注意事項に同意した上で</div>
                                                    イベントに申し込む
                                                </button>
                                                <button type="button" class="btn btn-luna-d disabled"
                                                    style="font-size: 18px; padding: 12px 0" disabled v-else>
                                                    <div style="font-size:10px">上記の注意事項に同意した上で</div>
                                                    申し込み受付は終了しました
                                                </button>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <div class="row justify-content-center" style="font-size: 14px;color:#6C7072">
                                            <div class="col">
                                                <p class="text-center">
                                                    インターネット異性紹介事業 届出済<br />登録番号: 30240011-000
                                                </p>
                                            </div>
                                        </div>
                                        <br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row" v-else>
                <div class="col">
                    <div class="alert alert-danger" role="alert" style="font-size: 11px">
                        お申し込みにはLunaのログイン/アカウントの作成が必要です
                    </div>
                    <div class="d-grid gap-2" style="padding: 0 5px">
                        <a type="button" class="btn btn-luna" href="#" @click="setRedirect()"
                            style="font-size: 18px; padding: 12px 0">ログイン</a>
                    </div>
                    <br>
                    <br>
                    <div class="row justify-content-center">
                        <div class="col-7">
                            <div class="d-grid gap-2" style="padding: 0 5px;">
                                <a :href="'/event/details/' + this.$route.params['eid']" type="button"
                                    class="btn btn-luna-d" style="font-size:12px;">イベントページへ戻る</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { clearPageStorage } from '../../event-log/clearPageStorage';
import {
    buildPaymentOptions,
    isPaymentOptionSelectable,
    isPrepaymentOnlyEvent,
    isPrepaymentRegistrationClosed,
} from './paymentOptions';

export default {
    data() {
        return {
            event: [],
            event_member: [],
            is_auth: false,
            is_recruit: true,
            member_count: 0,
            user: [],
            tel: "",
            email: "",
            is_tel_error: false,
            is_email_error: false,
            is_item_error: false,
            payments: [],
            payments_m: [],
            payments_f: [],
            payments_m_0: [],
            payments_f_0: [],
            payments_m_1: [],
            payments_f_1: [],
            payments_m_2: [],
            payments_f_2: [],
            payments_m_3: [],
            payments_f_3: [],
            item_payments: [],
            payment: null,
            sexs: [
                { value: "1", label: "女性" },
                { value: "2", label: "男性" },
            ],
            sex: null,
            types: [
                { value: "1", label: "S" },
                { value: "2", label: "M" },
                { value: "3", label: "スイッチャー" },
            ],
            type: null,
            comment: "",
            seat_types_2: [
                { value: "1", label: "一部参加" },
                { value: "2", label: "二部参加" },
                { value: "0", label: "通し参加" },
            ],
            seat_types_3: [
                { value: "1", label: "一部参加" },
                { value: "2", label: "二部参加" },
                { value: "3", label: "三部参加" },
                { value: "0", label: "通し参加" },
            ],
            seat_type: null,
            is_page_init: true,
            player: { value: "なし", label: "なし" },
            players: [],
        };
    },
    computed: {
        currentPaymentOptions() {
            if (this.seat_type == null || this.sex == null) {
                return this.payments;
            }

            const sex = this.sex.value == 1 ? "f" : "m";

            if (this.event.event_type == 0) {
                return this[`payments_${sex}`];
            }

            return this[`payments_${sex}_${this.seat_type.value}`] || this.payments;
        },
        isPrepaymentOnly() {
            return isPrepaymentOnlyEvent(this.event);
        },
        isPrepaymentOnlyRegistrationClosed() {
            return this.isPrepaymentOnly
                && isPrepaymentRegistrationClosed(this.event);
        },
    },
    methods: {
        async fetchEvent() {
            await axios
                .get("/api/event/show/" + this.$route.params["eid"])
                .then((response) => {
                    this.event = response.data.event;
                    this.players = response.data.players;

                    this.payments = buildPaymentOptions(this.event);
                    this.payments_f = buildPaymentOptions(this.event, this.event.amount1, this.event.amount3);
                    this.payments_m = buildPaymentOptions(this.event, this.event.amount2, this.event.amount4);
                    this.payments_f_1 = buildPaymentOptions(this.event, this.event.amount5, this.event.amount7);
                    this.payments_m_1 = buildPaymentOptions(this.event, this.event.amount6, this.event.amount8);
                    this.payments_f_2 = buildPaymentOptions(this.event, this.event.amount9, this.event.amount11);
                    this.payments_m_2 = buildPaymentOptions(this.event, this.event.amount10, this.event.amount12);
                    this.payments_f_3 = buildPaymentOptions(this.event, this.event.amount13, this.event.amount15);
                    this.payments_m_3 = buildPaymentOptions(this.event, this.event.amount14, this.event.amount16);
                    this.payments_f_0 = buildPaymentOptions(this.event, this.event.amount17, this.event.amount19);
                    this.payments_m_0 = buildPaymentOptions(this.event, this.event.amount18, this.event.amount20);

                    this.item_payments = Array.from(
                        { length: 20 },
                        (_, index) => this.event[`amount${index + 1}`]
                    );

                    if (this.event.event_type == 0) {
                        this.seat_type = { "value": "9" }
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("イベントの取得に失敗しました")
                    }
                });

            let response_auth = await axios.get("/api/user/is_auth");
            this.is_auth = response_auth.data.is_atuh;

            if (this.is_auth) {

                let _date = localStorage.getItem('luna_last_at')
                let _uid = localStorage.getItem('luna_uid')

                clearPageStorage();

                localStorage.setItem('luna_last_at', _date)
                localStorage.setItem('luna_uid', _uid)

                await axios
                    .get("/api/event/member/" + this.$route.params["eid"])
                    .then((response) => {
                        this.user = response.data.user;
                        this.tel = this.user.tel;
                        this.email = this.user.email;
                        this.member_count = response.data.member_count;
                        this.event_member = response.data.event_member;

                        if (this.event_member.sex == 1) {
                            this.sex = { value: "1", label: "女性" }
                        }
                        else if (this.event_member.sex == 2) {
                            this.sex = { value: "2", label: "男性" }
                        }

                        if (this.event_member.type == 1) {
                            this.type = { value: "1", label: "S" }
                        }
                        else if (this.event_member.type == 2) {
                            this.type = { value: "2", label: "M" }
                        }
                        else if (this.event_member.type == 3) {
                            this.type = { value: "3", label: "スイッチャー" }
                        }

                        if (this.event_member.seat_type == 1) {
                            this.seat_type = { value: "1", label: "一部参加" }
                        }
                        else if (this.event_member.seat_type == 2) {
                            this.seat_type = { value: "2", label: "二部参加" }
                        }
                        else if (this.event_member.seat_type == 3) {
                            this.seat_type = { value: "3", label: "三部参加" }
                        }
                        else if (this.event_member.seat_type == 0) {
                            this.seat_type = { value: "0", label: "通し参加" }
                        }
                        else if (this.event_member.seat_type == 9) {
                            this.seat_type = { value: "9" }
                        }

                        if (this.event_member.payment == 2 && !this.isPrepaymentOnly) {
                            // 当日決済
                            this.payment = { value: "2", label: "当日決済（現金のみ:" + this.event_member.amount.toLocaleString() + "円）", amount: this.event_member.amount }
                        }

                    });
            } else {
                localStorage.setItem("redirect", this.$route.path);
            }
            this.is_page_init = false
        },
        async setRecruit() {
            if (this.isPrepaymentOnlyRegistrationClosed) {
                this.$showErrorToast("支払期限を過ぎたため、申し込み受付は終了しました");
                return;
            }

            let str = String(this.event_member.tel);
            let is_tel = false;
            let is_url = false;
            let is_item = true;

            const regExp = new RegExp(
                /^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
            );

            // 入力項目チェック
            if (this.sex == null) {
                this.is_item_error = true;
                is_item = false;
            } else if (this.type == null) {
                this.is_item_error = true;
                is_item = false;
            } else if (this.seat_type == null || this.payment == null) {
                this.is_item_error = true;
                is_item = false;
            } else if (this.event_member.name == null) {
                this.is_item_error = true;
                is_item = false;
            } else {
                this.is_item_error = false;
                is_item = true;
            }

            // 半角数値チェック
            if (str == "") {
                this.is_tel_error = false;
                is_tel = true;
            } else if (str.match(/^[0-9]+$/)) {
                this.is_tel_error = false;
                is_tel = true;
            } else {
                this.is_tel_error = true;
                is_tel = false;
            }

            if (this.event_member.mail == null) {
                this.is_email_error = true;
                is_url = false;
            } else if (!regExp.test(this.event_member.mail)) {
                this.is_email_error = true;
                is_url = false;
            } else if (this.event_member.mail != "") {
                this.is_email_error = false;
                is_url = true;
            } else {
                this.is_email_error = true;
                is_url = false;
            }

            let p = (this.player.value == 'なし') ? null : this.player.value

            if (is_url && is_tel && is_item) {
                await axios
                    .post("/api/event/re/recruit", {
                        uid: this.user.id,
                        eid: this.event.id,
                        emid: this.event_member.id,
                        tel: this.event_member.tel,
                        email: this.event_member.mail,
                        name: this.event_member.name,
                        comment: this.comment,
                        sex: this.sex.value,
                        type: this.type.value,
                        payment: this.payment.value,
                        seat_type: this.seat_type.value,
                        amount: this.payment.amount,
                        player: p,
                    })
                    .then((response) => {
                        window.location.href = "/event/completion";
                    })
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else if (error.response && error.response.status == 422) {
                            this.$showErrorToast("入力内容または支払期限をご確認ください")
                        }
                        else {
                            this.$showErrorToast("イベントの申し込みに失敗しました")
                        }
                    });
            }
        },
        setRedirect() {
            localStorage.setItem("redirect", this.$route.path);
            window.location.href = "/auth";
        },
        isPaymentSelectable(option) {
            return isPaymentOptionSelectable(option);
        },
        chengeSex() {
            if (this.payment == null || this.sex == null || this.seat_type == null) {
                return;
            }

            // 表示額の対応は EventController::setReRecruit の正規料金算出と一致させること。
            // amount1〜amount20 の対応を変更する場合は、同処理と SetReRecruitTest::amountProvider も更新する。
            const amountIndex = {
                "9": { "1": { "1": 0, "2": 2 }, "2": { "1": 1, "2": 3 } },
                "1": { "1": { "1": 4, "2": 6 }, "2": { "1": 5, "2": 7 } },
                "2": { "1": { "1": 8, "2": 10 }, "2": { "1": 9, "2": 11 } },
                "3": { "1": { "1": 12, "2": 14 }, "2": { "1": 13, "2": 15 } },
                "0": { "1": { "1": 16, "2": 18 }, "2": { "1": 17, "2": 19 } },
            };
            const seatAmounts = amountIndex[this.seat_type.value];
            const sexAmounts = seatAmounts ? seatAmounts[this.sex.value] : null;
            const index = sexAmounts ? sexAmounts[this.payment.value] : undefined;

            if (index === undefined
                || (this.payment.value === "1" && isPrepaymentRegistrationClosed(this.event))
            ) {
                this.payment = null;
                return;
            }

            const amount = this.item_payments[index];
            const isPrepayment = this.payment.value === "1";
            this.payment = {
                value: this.payment.value,
                label: (isPrepayment ? "事前決済（Web決済:" : "当日決済（現金のみ:")
                    + amount.toLocaleString() + "円）",
                amount: amount,
            };
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchEvent();
                        })
                    .catch((error) => {
                        window.location.href = "/error"
                    })
            }
            else {
                this.fetchEvent();
            }
        }
        else {
            this.fetchEvent();
        }
    },
    filters: {
        priceLocaleString(value) {
            if (value != undefined) {
                return value.toLocaleString();
            } else {
                return value;
            }
        },
    },
};
</script>
<style>
.luna-item-bar {
    background: #6b4eff;
    color: #fff;
}

.subtitle {
    padding: 10px;
    font-size: 20px;
    border-bottom: 2px solid #6b4eff;
}</style>
